import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface MobileNavigationProps {
  unreadCount?: number;
}

export const MobileNavigation: React.FC<MobileNavigationProps> = ({ unreadCount = 0 }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [showDrawer, setShowDrawer] = useState(false);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const navigationItems = [
    {
      path: '/',
      label: 'Accueil',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      )
    },
    // {
    //   path: '/communities',
    //   label: 'Communautés',
    //   icon: (
    //     <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //       <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 12a8 8 0 0116 0" />
    //     </svg>
    //   )
    // },
    {
      path: '/messages',
      label: 'Messages',
      badge: unreadCount > 0 ? unreadCount : undefined, // Ne définir badge que s'il y a des messages
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      )
    },
    {
      path: '/settings',
      label: 'Paramètres',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    }
  ];

  return (
    <>
      {/* Mobile Bottom Navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-30 cosmic-card border-t border-emerald-700/30">
        <div className="mobile-safe-area">
          <nav className="flex justify-around py-2">
          {navigationItems.slice(0, 4).map((item) => (
            <Link 
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center p-2 min-w-[60px] btn-touch relative ${
                isActive(item.path) ? 'text-emerald-400' : 'text-gray-400 hover:text-emerald-300'
              }`}
            >
              <div className="relative">
                {item.icon}
                {/* Pastille colorée dynamique pour les messages */}
                {item.path === '/messages' && item.badge && item.badge > 0 && (
                  <div className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-r from-red-500 to-orange-500 rounded-full border-2 border-gray-900 animate-pulse shadow-lg shadow-red-500/50">
                  </div>
                )}
              </div>
              <span className="text-xs mt-1 truncate">{item.label}</span>
            </Link>
          ))}
          
          {/* Menu Button */}
          <button
            onClick={() => setShowDrawer(true)}
            className="flex flex-col items-center p-2 min-w-[60px] btn-touch text-gray-400 hover:text-emerald-300"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <span className="text-xs mt-1">Menu</span>
          </button>
        </nav>
        </div>
      </div>

      {/* Mobile Drawer Overlay */}
      {showDrawer && (
        <div 
          className="md:hidden fixed inset-0 z-50 bg-black/50 backdrop-blur-sm"
          onClick={() => setShowDrawer(false)}
        >
          {/* Drawer */}
          <div 
            className="fixed right-0 top-0 h-full w-80 max-w-[85vw] cosmic-card border-l border-emerald-700/30 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Drawer Header */}
            <div className="p-4 border-b border-emerald-700/30">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <img
                    src="https://i.imgur.com/FKIlY9U.jpeg"
                    alt="Jupipotes Logo"
                    className="h-8 w-8 object-cover rounded-full border-2 border-emerald-400"
                  />
                  <h2 className="text-lg font-bold text-emerald-300">Jupipotes</h2>
                </div>
                <button
                  onClick={() => setShowDrawer(false)}
                  className="p-2 hover:bg-emerald-800/30 rounded text-emerald-400"
                >
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            {/* User Profile Section */}
            {user && (
              <div className="p-4 border-b border-emerald-700/30">
                <Link 
                  to={`/profile/${user.id}`}
                  onClick={() => setShowDrawer(false)}
                  className="flex items-center space-x-3 hover:bg-emerald-800/20 p-3 rounded-lg"
                >
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                    {user.displayName?.charAt(0) || '🚀'}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-emerald-200 truncate">{user.displayName || 'Jupipote'}</p>
                    <p className="text-sm text-emerald-400 truncate">{user.walletAddress?.substring(0, 10)}...</p>
                  </div>
                </Link>
              </div>
            )}

            {/* Navigation Links */}
            <div className="p-4">
              <nav className="space-y-2">
                <Link 
                  to="/JUPResources"
                  onClick={() => setShowDrawer(false)}
                  className={`flex items-center space-x-3 p-3 rounded-lg ${
                    isActive('/JUPResources') ? 'bg-emerald-700/30 text-emerald-300' : 'hover:bg-emerald-800/20 text-emerald-100'
                  }`}
                >
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 20h9M12 4h9M4 4h.01M4 9h16M4 15h16M4 20h.01" />
                  </svg>
                  <span>Ressources JUP</span>
                </Link>

                <Link 
                  to="/AboutJUP"
                  onClick={() => setShowDrawer(false)}
                  className={`flex items-center space-x-3 p-3 rounded-lg ${
                    isActive('/AboutJUP') ? 'bg-emerald-700/30 text-emerald-300' : 'hover:bg-emerald-800/20 text-emerald-100'
                  }`}
                >
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>À propos de JUP</span>
                </Link>

                {/* Logout */}
                <button
                  onClick={() => {
                    // Implement logout
                    setShowDrawer(false);
                  }}
                  className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-red-800/20 text-red-400"
                >
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  <span>Se déconnecter</span>
                </button>
              </nav>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
